import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DetalheRoteiroResponse, ListarPGRRequest, ListarPGRResponse, ListarRoteirosRequest, ListarRoteirosResponse, ListarTransportadorasRequest, ListarTransportadorasResponse, ListarUnidadesResponse, ListarVeiculosEMotoristasRequest, ListarVeiculosEMotoristasResponse } from 'src/app/@shared/models/manifesto-embarque-gerar.model';
import { ListarManifestoEmbarquePendenciasRequest, ListarManifestoEmbarquePendenciasRotaRequest } from 'src/app/@shared/models/manifesto-embarque.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const filtro = (obj: ListarManifestoEmbarquePendenciasRequest | ListarManifestoEmbarquePendenciasRotaRequest) => {
  const filtro = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filtro);
};

const listarRoteirosFiltro = (obj: ListarRoteirosRequest) => {
  return `${obj.roteiroID ? `roteiroID=${obj.roteiroID}&` : ''}`
    + `${obj.roteiro ? `roteiro=${obj.roteiro}&` : ''}`
    + `${obj.cidadeOrigem ? `cidadeOrigem=${obj.cidadeOrigem}&` : ''}`
    + `${obj.cidadeDestino ? `cidadeDestino=${obj.cidadeDestino}&` : ''}`
    + `${obj.tipoRoteiroID ? `tipoRoteiroID=${obj.tipoRoteiroID}&` : ''}`
}

const listarTransportadorasFiltro = (obj: ListarTransportadorasRequest) => {
  return `${obj.razaoSocial ? `razaoSocial=${obj.razaoSocial}&` : ''}`
    + `${obj.transportadoraID ? `transportadoraID=${obj.transportadoraID}&` : ''}`
    + `${obj.ativo ? `ativo=${obj.ativo}&` : ''}`
    + `${obj.tipo ? `tipo=${obj.tipo}&` : ''}`
    + `${obj.exibeNovoME ? `exibeNovoME=${obj.exibeNovoME}&` : ''}`
}

const listarVeiculosEMotoristasFiltro = (obj: ListarVeiculosEMotoristasRequest) => {
  return `${obj.transportadoraID ? `transportadoraID=${obj.transportadoraID}&` : ''}`
  + `${obj.empresaId ? `empresaId=${obj.empresaId}&` : ''}`
  + `${obj.placaVeiculo ? `placaVeiculo=${obj.placaVeiculo}&` : ''}`
  + `${obj.exibeNovoME ? `exibeNovoME=${obj.exibeNovoME}` : ''}`
}

const listarPGR = (obj: ListarPGRRequest) => {
  return `${obj.cidadeIdDestino ? `cidadeIdDestino=${obj.cidadeIdDestino}` : ''}`
}

const listarUnidadeFiltro = (obj: ListarUnidadesResponse) => {
  return `${obj.descricao ? `descricao=${obj.descricao}&` : ''}`
    + `${obj.UnidadeId ? `unidadeID=${obj.UnidadeId}&` : ''}`
}

@Injectable({
  providedIn: 'root'
})
export class ManifestoEmbarqueGerarService {

  constructor(
    private http: HttpClient
  ) { }

  listarRoteiros(obj?: ListarRoteirosRequest): Observable<ListarRoteirosResponse[]> {
    return this.http.get<ListarRoteirosResponse[]>(
      `Manifesto-Embarque/ListarRoteiros?${obj ? listarRoteirosFiltro(obj) : ''}`,
      httpOptions
    );
  }

  listarEmpresas(): Observable<any[]> {
    return this.http.get<any[]>(
      `EmpresaXAgente/ConsultaEmpresas`,
      httpOptions
    );
  }

  obterDadosRoteiro(roteiroId: number): Observable<DetalheRoteiroResponse> {
    return this.http.get<DetalheRoteiroResponse>(`Roteiro/obtenhaDados/${roteiroId}`, httpOptions)
  }

  listarIataPorRoteiro(roteiroId: number): Observable<any> {
    return this.http.get<any>(`GeracaoManifestoEmbarque/Dropdown/ListarIATAPorRoteiro/${roteiroId}`, httpOptions)
  }

  listarTransportadorasPorPlaca(obj: any): Observable<any> {
    return this.http.get<any>(`GeracaoManifestoEmbarque/Dropdown/ListarTransportadoras?${filtro(obj)}`, httpOptions)
  }

  // verificaPendenciasPorRoteiro(roteiroId: number): Observable<any> {
  //   return this.http.get<any>(`GeracaoManifestoEmbarque/IdentificarPendencia?RoteiroId=${roteiroId}`, httpOptions)
  // }

  consultaPendencias(obj: ListarManifestoEmbarquePendenciasRotaRequest): Observable<any> {
    return this.http.get<any>(`GeracaoManifestoEmbarque/Pendencias/ListarIATA?${filtro(obj)}`, httpOptions)
  }

  consultaPendenciasDetalhesPedido(obj: ListarManifestoEmbarquePendenciasRotaRequest): Observable<any> {
    return this.http.get<any>(`GeracaoManifestoEmbarque/DetalhesPedido/ListarIATA?${filtro(obj)}`, httpOptions)
  }

  consultaDetalhesPedidoVolume(obj: ListarManifestoEmbarquePendenciasRotaRequest): Observable<any> {
    return this.http.get<any>(`GeracaoManifestoEmbarque/ListaMTVolumeDetalhamento?${filtro(obj)}`, httpOptions)
  }

  listarTransportadoras(obj?: ListarTransportadorasRequest): Observable<ListarTransportadorasResponse[]> {
    return this.http.get<ListarTransportadorasResponse[]>(
      `Manifesto-Embarque/ListarTransportadoras?${obj ? listarTransportadorasFiltro(obj) : ''}`,
      httpOptions
    );
  }

  listarVeiculosEMotoristas(obj?: ListarVeiculosEMotoristasRequest): Observable<ListarVeiculosEMotoristasResponse> {
    return this.http.get<ListarVeiculosEMotoristasResponse>(
      `Manifesto-Embarque/ListarVeiculosEMotoristas?${obj ? listarVeiculosEMotoristasFiltro(obj) : ''}`,
      httpOptions
    );
  }

  listarPGR(obj?: ListarPGRRequest): Observable<ListarPGRResponse[]>{
    return this.http.get<ListarPGRResponse[]>(
      `Manifesto-Embarque/ListarPgr?${obj ? listarPGR(obj) : ''}`,
      httpOptions
    )
  }

  validarManifesto(obj?: any): Observable<any[]> {
    return this.http.post<any[]>(
      `Manifesto-Embarque/ValidacaoManifesto`, obj, httpOptions
    )
  }

  gerarManifesto(obj?: any): Observable<any[]> {
    return this.http.post<any[]>(
      `Manifesto-Embarque/Gerar`, obj, httpOptions
    )
  }

  public exportarExcel(obj: any): Observable<any> {
    return this.http.get<any>(`Manifesto-Embarque/ExportarExcel?${filtro(obj)}`, httpOptions);
  }

  public exportarExcelPendencias(obj: any): Observable<any> {
    return this.http.get<any>(`GeracaoManifestoEmbarque/Pendencias/Exportar?${filtro(obj)}`, httpOptions);
  }

  public exportarExcelDetalhesPedido(obj: any): Observable<any> {
    return this.http.get<any>(`GeracaoManifestoEmbarque/DetalhesPedido/Exportar?${filtro(obj)}`, httpOptions);
  }


  listarUnidade(obj?: ListarUnidadesResponse): Observable<ListarUnidadesResponse[]> {
    return this.http.get<ListarUnidadesResponse[]>(
      `Manifesto-Embarque/ListarUnidade?${obj ? listarUnidadeFiltro(obj) : ''}`,
      httpOptions
    );
  }
}
